import { useState, useEffect, useCallback } from 'react';
import { ApiFactory } from '../../core/config/ApiFactory';
import { IConfiguracaoEstacaoSimplesKDS, IConfiguracaoKDSEstabelecimento, ModoDisparo, TipoKDS } from '../interfaces/IKDS';

export const useConfiguracaoKDS = () => {
    const [configuracao, setConfiguracao] = useState<IConfiguracaoKDSEstabelecimento>({
        modoDisparo: 'automatico',
        tipoKDS: 'completo',
        configuracoesEstacaoSimples: [],
    });
    const [loading, setLoading] = useState(false);
    const apiProdutos = ApiFactory.getApi("MS_PRODUTOS");
    const apiPedidos = ApiFactory.getApi("MS_PEDIDOS");

    const carregar = useCallback(async () => {
        setLoading(true);
        try {
            const [resProdutos, resPedidos] = await Promise.all([
                apiProdutos.get('/kds/configuracao'),
                apiPedidos.get('/kds/configuracao-kds'),
            ]);
            setConfiguracao({
                modoDisparo: resProdutos.data.configuracao?.modoDisparo ?? 'automatico',
                tipoKDS: resPedidos.data.tipoKDS ?? 'completo',
                configuracoesEstacaoSimples: resPedidos.data.configuracoesEstacaoSimples ?? [],
            });
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { carregar(); }, [carregar]);

    const salvarModoDisparo = async (modoDisparo: ModoDisparo) => {
        await apiProdutos.patch('/kds/configuracao', { modoDisparo });
        setConfiguracao(prev => ({ ...prev, modoDisparo }));
    };

    /** @deprecated Use salvarModoDisparo */
    const salvar = salvarModoDisparo;

    const salvarTipoKDS = async (tipoKDS: TipoKDS, configuracoesEstacaoSimples?: IConfiguracaoEstacaoSimplesKDS[]) => {
        const body: any = { tipoKDS };
        if (configuracoesEstacaoSimples !== undefined) body.configuracoesEstacaoSimples = configuracoesEstacaoSimples;
        await apiPedidos.patch('/kds/configuracao-kds', body);
        setConfiguracao(prev => ({
            ...prev,
            tipoKDS,
            ...(configuracoesEstacaoSimples !== undefined ? { configuracoesEstacaoSimples } : {}),
        }));
    };

    return {
        configuracao,
        loading,
        carregar,
        salvar,
        salvarModoDisparo,
        salvarTipoKDS,
        kdsDesabilitado: configuracao.tipoKDS === 'desabilitado',
        kdsSimples: configuracao.tipoKDS === 'simples',
        kdsCompleto: configuracao.tipoKDS === 'completo',
    };
};
